<template>
	<div class="_modal bg-white">
		<div
			class="
				_modal__content
				px-12
				py-6
				flex flex-col
				items-center
				justify-center
			"
		>
			<div>
				<img
					src="@/assets/images/illustrations/send.png"
					alt="Luca Education"
					title="Luca Education"
					height="60"
					width="60"
				/>
			</div>
			<div
				class="
					_modal__content__title
					text-neutral-700
					font-semibold
					text-2xl
					mt-5
					text-center
				"
			>
				Gửi điểm danh này tới Phụ huynh?
			</div>
			<div class="text-center text-neutral-500 mt-2">
				Điểm danh này sẽ được gửi tới Phụ huynh
			</div>
			<div class="flex w-full gap-8 mt-4">
				<div class="image-block" v-if="data?.checkin">
					<div style="height: 182px">
						<img
							v-if="data?.checkin?.media"
							class="w-full h-full object-cover rounded-lg"
							:src="data?.checkin?.media?.asset_url"
							alt=""
						/>
						<img
							v-else
							class="w-full h-full object-cover rounded-lg"
							src="@/assets/images/illustrations/checkin.png"
							alt=""
						/>
					</div>

					<div class="flex items-center gap-1 mt-2">
						<img
							class="w-5 h-5"
							src="@/assets/images/icons/checkin.png"
							alt=""
						/>
						<div class="text-neutral-700 font-semibold">
							{{ data?.checkin?.display_time }}
						</div>
					</div>
				</div>
				<div class="image-block" v-if="data?.checkout">
					<div style="height: 182px">
						<img
							v-if="data?.checkout?.media"
							class="w-full h-full object-cover rounded-lg"
							:src="data?.checkout?.media?.asset_url"
							alt=""
						/>
						<img
							v-else
							class="w-full h-full object-cover rounded-lg"
							src="@/assets/images/illustrations/checkout.png"
							alt=""
						/>
					</div>

					<div class="flex items-center gap-1 mt-2">
						<img
							class="w-5 h-5"
							src="@/assets/images/icons/checkout.png"
							alt=""
						/>
						<div class="text-neutral-700 font-semibold">
							{{ data?.checkout?.display_time }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="
				_modal__footer
				px-12
				py-6
				bg-neutral-50
				flex flex-nowrap
				items-center
			"
		>
			<button
				type="button"
				class="
					button-p
					text-center
					mr-3
					bg-none
					shadow-none
					text-neutral-500
					hover:text-neutral-700
				"
				@click="$emit('close')"
			>
				Thoát
			</button>
			<button
				type="button"
				class="button-p text-center whitespace-nowrap"
				@click="submit"
			>
				Xác nhận
			</button>
		</div>
	</div>
</template>

<script>
import { $api } from '@/services';

export default {
	name: 'SendDataModal',
	props: {
		data: {
			type: Object,
			required: true,
		},
		dayCare: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		async submit() {
			try {
				let params = {};
				if (this.dayCare) {
					params = {
						day_care_report_id: this.data.id,
					};
				} else {
					params = {
						lesson_report_id: this.data.id,
					};
				}
				await $api.lessonReport.sendAttendance(params);
				await this.$store.dispatch('setAlertMessage', {
					message: 'Gửi điểm danh thành công',
				});
				this.$emit('success');
			} catch (e) {
				await this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},
	},
};
</script>
<style scoped>
.image-block {
	width: calc(50% - 16px);
}
</style>
